import React, { useState } from "react";
import Layout from "../form-layout";
import DoseSelector from "./dose-selector";
import { GLP1_MEDICATIONS, FORM_B_CURRENT_MEDICATIONS } from "../../data/eligibility-rules";

// Form B Q2 — "What dose are you currently using?" (skipped when Q1 = "Other")
export default function CurrentDose({ formData, setFormData, onBack, goToStep }) {
  const medication = GLP1_MEDICATIONS.find((m) => m.key === formData.currentGlp1Med);
  const selectedMedLabel = FORM_B_CURRENT_MEDICATIONS.find((m) => m.key === formData.currentGlp1Med)?.label;
  const [dose, setDose] = useState(formData.currentDose || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (medication?.doseOptions?.length && !dose) return;

    setFormData((prev) => ({ ...prev, currentDose: dose }));
    localStorage.setItem("currentDose", dose);

    goToStep("b3");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-1">
        What dose are you currently using?
      </h2>
      {selectedMedLabel && (
        <p className="text-sm text-[#35C3D9] font-semibold mb-5">{selectedMedLabel}</p>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <DoseSelector doseOptions={medication?.doseOptions} selected={dose} onSelect={setDose} />

        <div className="flex justify-start mt-2">
          <button
            type="submit"
            disabled={Boolean(medication?.doseOptions?.length) && !dose}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                Boolean(medication?.doseOptions?.length) && !dose
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
